/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import type { ToggleDisabledStatus } from '../../components/SnippetsContainer/Snippets/types';
import { INSTALL_METHODS } from '../../constants/installation';
import type { GetCodeOutputToggleStatusArgs } from './types';

const ZIP_METHOD_NAME = INSTALL_METHODS.find( method => method.key === 'zip' )!.name;

export function getCodeOutputToggleStatus( {
	key,
	selectedTechnology,
	selectedInstallMethod,
	hasPremiumPlugins,
	isLoggedIn
}: GetCodeOutputToggleStatusArgs ): ToggleDisabledStatus {
	if ( !selectedTechnology || !selectedInstallMethod ) {
		return {
			disabled: true,
			tooltip: 'Select the technology and integration method first.'
		};
	}

	if ( ( isLoggedIn || hasPremiumPlugins ) && key === 'stackblitz' ) {
		return {
			disabled: true,
			tooltip: 'This option is disabled to prevent license leakage.'
		};
	}

	if ( selectedInstallMethod === 'zip' && key !== 'download' ) {
		return {
			disabled: true,
			tooltip: `The ${ ZIP_METHOD_NAME } installation method is intended for download only.`
		};
	}

	return { disabled: false, tooltip: null };
}
